import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { LabelFilterSelectedValues } from '../../../configs/label-filter-config/filter-selected-values';
import { labelFilterConfig } from '../../../configs/label-filter-config';

export const LeadLabelsFilter = () => {
  return (
    <InputFilterTrigger
      renderValues={LabelFilterSelectedValues}
      filterLabel='Label'
      config={labelFilterConfig}
    />
  );
};
